import { render } from "./SingleStatusModal.vue?vue&type=template&id=4c951997&bindings={}"
import script from "./SingleStatusModal.vue?vue&type=script&lang=ts"
export * from "./SingleStatusModal.vue?vue&type=script&lang=ts"
script.render = render

export default script